<ng-container>
  <mat-divider />
  <mat-form-field appearance="fill" class="m-t-10">
    <mat-label>Entry Configuration</mat-label>
    <mat-select [(value)]="entryOption">
      <mat-option [value]="EntryOptionType.ACCOUNT">Account</mat-option>
      <mat-option [value]="EntryOptionType.CUSTOM_RULES">Custom Rules</mat-option>
      <mat-option [value]="EntryOptionType.DEFAULT">Default</mat-option>
      <mat-option [value]="EntryOptionType.STARTING_POINT">Starting Point</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="flex flex-row">
    <mat-form-field appearance="fill">
      <mat-label>Group Former Number</mat-label>
      <input matInput id="groupFormer" type="number" [(ngModel)]="groupFormerCount" />
    </mat-form-field>
  </div>
  <div class="m-b-10">
    <button mat-raised-button color="primary" (click)="onSaveEntryConfiguration()" [disabled]="!entrySettingsDirty">
      Update Entry Configuration
    </button>
  </div>
</ng-container>

<mat-divider />

<mat-form-field appearance="fill" class="m-t-10">
  <mat-label>Presenter Count</mat-label>
  <mat-select [(value)]="presenterCount" (valueChange)="updatePresenterCount()">
    <mat-option [value]="1">1</mat-option>
    <mat-option [value]="2">2</mat-option>
    <mat-option [value]="3">3</mat-option>
    <mat-option [value]="4">4</mat-option>
  </mat-select>
</mat-form-field>

<mat-divider />

<div class="flex flex-row">
  <mat-form-field appearance="fill" class="m-t-10">
    <mat-label>Starting Point</mat-label>
    <mat-select [(value)]="startingPointId" (valueChange)="updateStartingPoint()">
      @for (room of roomSet?.socials; track room) {
        <mat-option [value]="room.socialId">{{ room.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<mat-divider />

<h3>Auto-zoom</h3>
<p style="max-width: 290px">These settings are local, and do not persist to the server.</p>
<div class="flex flex-row">
  <mat-form-field appearance="fill" class="m-t-10">
    <mat-label>Easing: see <a href="https://easings.net/">easings.net</a> </mat-label>
    @if (snapZoomOptions) {
      <mat-select [(value)]="snapZoomOptions.ease" (valueChange)="updateSnapZoomOptions()">
        @for (easing of easings; track easing) {
          <mat-option [value]="easing.name">{{ easing.name }}</mat-option>
        }
      </mat-select>
    }
  </mat-form-field>
</div>
<div class="flex flex-row">
  <mat-form-field appearance="fill" class="m-t-10">
    <mat-label>Zoom ratio <small>level / ratio = padding</small></mat-label>
    @if (snapZoomOptions) {
      <input
        matInput
        id="snapOptions"
        type="number"
        [(ngModel)]="snapZoomOptions.ratio"
        (valueChange)="updateSnapZoomOptions()"
      />
    }
  </mat-form-field>
</div>
<div>
  <small>Current Zoom level:</small>
  <br />
  {{ sceneService.sceneManager?.currentZoom | number: '1.2-2' }}
</div>
<div class="flex flex-row">
  <mat-form-field appearance="fill" class="m-t-10">
    <mat-label>Zoom delay <small>(ms addition to the "is moving" delay)</small></mat-label>
    @if (snapZoomOptions) {
      <input
        matInput
        id="snapOptions"
        type="number"
        [(ngModel)]="snapZoomOptions.delay"
        (valueChange)="updateSnapZoomOptions()"
      />
    }
  </mat-form-field>
</div>
<div class="flex flex-row">
  <mat-form-field appearance="fill">
    <mat-label>Zoom time <small>(ms for zoom to complete)</small></mat-label>
    @if (snapZoomOptions) {
      <input
        matInput
        id="snapOptions"
        type="number"
        [(ngModel)]="snapZoomOptions.time"
        (valueChange)="updateSnapZoomOptions()"
      />
    }
  </mat-form-field>
</div>

<mat-divider />

<div class="m-t-10">
  @for (setting of settings | keyvalue; track setting) {
    <div>{{ setting.key }}: {{ mapRoomSetting(setting.key, setting.value) }}</div>
  }
</div>

<mat-divider />

<h3>Presentation Transition Options:</h3>
<div class="flex flex-row">
  <mat-form-field appearance="fill">
    <mat-label>Audio fade time (ms)</mat-label>
    <input matInput id="audioFade" type="number" [(ngModel)]="audioFadeTimeout" />
  </mat-form-field>
</div>

<div class="flex flex-row">
  <mat-form-field appearance="fill">
    <mat-label>Background fade out time (ms)</mat-label>
    <input matInput id="backgroundFadeOutTimeout" type="number" [(ngModel)]="backgroundFadeOutTimeout" />
  </mat-form-field>
</div>

<div class="flex flex-row">
  <mat-form-field appearance="fill">
    <mat-label>Presentation Icon fade in time (ms)</mat-label>
    <input matInput id="presentationIconFadeIn" type="number" [(ngModel)]="presentationIconFadeIn" />
  </mat-form-field>
</div>

<div class="flex flex-row">
  <mat-form-field appearance="fill">
    <mat-label>Transition Loading time (ms)</mat-label>
    <input matInput id="transitionLoadTimeout" type="number" [(ngModel)]="transitionLoadTimeout" />
  </mat-form-field>
</div>
<div class="m-b-10">
  <button mat-raised-button color="primary" (click)="onSaveTransitionTimers()">Update Transition Times</button>
</div>
